export const CSV_TEMPLATE = {
  DMS: 'dms',
  NON_DMS: 'nonDMS',
  BULK_UNASSIGN_USERS: 'bulkUnassignUsers'
};
